
export default {
  props: {
    admId: {
      type: String,
      required: true
    },
    admUnit: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.handleIntersection();
  },
  methods: {
    handleIntersection() {
      const width = this.$refs.admSlot.clientWidth;
      const height = this.$refs.admSlot.clientHeight - this.$refs.title.clientHeight;
      console.log(width, height, this.$refs.admSlot.clientHeight, this.$refs.title.clientHeight);
      const adScript = document.createElement("script");
      adScript.innerHTML = `googletag.cmd.push(function () {
              googletag.defineSlot('${this.admUnit}', ['fluid', [${width},${height}]], '${this.admId}').addService(googletag.pubads());
              googletag.enableServices();
              googletag.display('${this.admId}');
            });`;
      this.$refs.googleAdmSlot.appendChild(adScript);
    }
  }
};
